import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

const useStudentAttendance = (student_uid:string) => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const {getBranchId} = useGetBranchId();
    const [attendedDates, setAttendedDates] = useState<number[]>([]);
    const [percent, setPercent] = useState(0);
    const [schoolDay, setSchoolDay] = useState(0);
    const {readFirestoreOneDoc} = useFirestore();
    const max_day = new Date(year, month + 1, 0).getDate();

    useEffect(() => {
        getAttendedDates(year, month);
        // eslint-disable-next-line
    }, [year, month])

    useEffect(() => {
        if(attendedDates.length && schoolDay !== 0){
            calculatePercent();
        }
        // eslint-disable-next-line
    }, [attendedDates, schoolDay])

    const calculatePercent = () => {
        setPercent((attendedDates.length / schoolDay) * 100);
    }
    

    const getAttendedDates = async(year:number, month:number) => {
        const branch_id = await getBranchId();
        let school_day_count = 0;
        for(let i = 1; i <= max_day; i++){
            const state = await readFirestoreOneDoc(`/Attendance/${branch_id}/${year}/${month + 1}/${i}`, student_uid).then(res => {
                if(res.exists()){
                    school_day_count += 1;
                    return res.data().state;
                }
                return null;
            })
            if(state === 'attend'){
                setAttendedDates(prev => [...prev, i]);
            }
        }
        setSchoolDay(school_day_count);
    }

    return {attendedDates, percent};
}

export default useStudentAttendance;